import { defineMessages } from 'react-intl'

const scope = `procurify.purchasing.presenter.EditApprovalPoolSettingTogglePresenter`

export default defineMessages({
  approvalPoolsHeader: {
    id: `${scope}.approvalPoolsHeader`,
    defaultMessage: 'Approval pools (only applies to Request for Order)',
  },
  onLabel: {
    id: `${scope}.onLabel`,
    defaultMessage: 'On',
  },
  offLabel: {
    id: `${scope}.offLabel`,
    defaultMessage: 'Off',
  },
  approvalPoolsDescription: {
    id: `${scope}.approvalPoolsDescription`,
    defaultMessage:
      'Once enabled, all approvers in the same level are notified, and any of them can approve pending orders. This only applies to Request for Order.',
  },
  approvalPoolsEnabledSuccessTitle: {
    id: `${scope}.approvalPoolsEnabledSuccessTitle`,
    defaultMessage: 'Approval pools enabled',
  },
  approvalPoolsEnabledSuccessMessage: {
    id: `${scope}.approvalPoolsEnabledSuccessMessage`,
    defaultMessage:
      'Any of the approvers from the same level can approve pending orders.',
  },
  approvalPoolsDisabledSuccessTitle: {
    id: `${scope}.approvalPoolsDisabledSuccessTitle`,
    defaultMessage: 'Approval pools disabled',
  },
  approvalPoolsDisabledSuccessMessage: {
    id: `${scope}.approvalPoolsDisabledSuccessMessage`,
    defaultMessage:
      'A specific approver must be assigned for each pending order.',
  },
  defaultErrorToastMessage: {
    id: `${scope}.defaultErrorToastMessage`,
    defaultMessage: 'Approval pools setting could not be updated.',
  },
})
